import { ModalAddCgChargeComponent } from './../../../shared/components/modals/modal-add-cg-charge/modal-add-cg-charge.component';
import { TypeCompService } from '../../../shared/services/simple/type-comp.service';
import { CgChargeService } from 'src/app/shared/services/simple/cg-charge.service';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';

@Component({
  selector: 'app-gestion-cg-charge',
  templateUrl: './gestion-cg-charge.component.html',
  styleUrls: ['./gestion-cg-charge.component.scss']
})
export class GestionCgChargeComponent implements OnInit {

  cgCharges: CgChargeModel[] = [];
  displayedColumns: string[] = ['code', 'libelle', 'action'];
  dataSource: CgChargeModel[];
  matDataSource = new MatTableDataSource<CgChargeModel>();
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageSize = 25;
  objet: SimpleQueryUser = new SimpleQueryUser();
  pageEvent: PageEvent;
  idSociete: number;
  result: boolean;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private cgChargeService: CgChargeService,
    private typeCompService: TypeCompService,
    private toastrService: ToastrService,
    private gestionReferentielComponent: GestionReferentielComponentService) { }

  ngOnInit(): void {
      this.idSociete = 69;
      this.objet.query = '';
      this.objet.pageNumber = 0;
      this.objet.pageSize = this.pageSize;
      this.objet.order = 'libelle';
      this.matDataSource.paginator = this.paginator;
      this.loadPage();
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateCgChargeFormGroup();
    form.get('idSociete').setValue(this.idSociete);
    const dialogRef = this.dialog.open(ModalAddCgChargeComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.idSociete,
          form,
          cgCharges: this.cgCharges,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });

  }

  onModify(cg: CgChargeModel): void {
    const form = this.gestionReferentielComponent.getEditCgChargeFormGroup(cg);
    const dialogRef = this.dialog.open(ModalAddCgChargeComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.idSociete,
          form,
          cgCharges: this.cgCharges,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(cg: CgChargeModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du CG Charge',
        message: 'Êtes-vous sur de vouloir supprimer le CG Charge ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.cgChargeService.delete(cg.id).subscribe((response: CgChargeModel) => {
          this.toastrService.success('Le CG Charge a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }

  orderUsers(cgCharges: CgChargeModel[]): CgChargeModel[] {
    cgCharges = cgCharges.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return cgCharges;
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.idSociete;
    this.cgChargeService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<CgChargeModel>) => {
      if (query.objets != null) {
        this.cgCharges = query.objets;
      } else {
        this.cgCharges = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<CgChargeModel>(this.cgCharges);
      this.paginator.length = this.length;
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}

